import styled from '~/app/components/styled'
import { Typography } from '@yanolja-rnd/ya-com-core'

export const TitleDescContainer = styled.div`
  padding-top: 2rem;
`

export const TitleWrapper = styled.div`
  ${Typography('subtitle2').bold};
  color: ${({ theme }) => theme.color.gray900};
  margin-bottom: 0.4rem;
  cursor: pointer;
`
export const DescWrapper = styled.div`
  ${Typography('body2').regular};
  color: ${({ theme }) => theme.color.gray600};
  .bar {
    margin-left: 0.6rem;
    margin-right: 0.6rem;
  }
`
export const ItemWrapper = styled.div`
  border-top: solid 1px ${({ theme }) => theme.color.gray200};
  margin-top: 2rem;
  padding-top: 2rem;
  &:nth-of-type(2) {
    margin-top: 1.6rem;
  }
`
